import { IAction } from 'helpers/interfaces';
import { canAccessPlayerProfile, dateFormatter, localStorageHelper } from 'utils';
import { IPlayerData } from 'redux/reducers/backoffice/player-report-reducer';
import { PlayersReportTypes } from 'redux/actions/backoffice/players-report-actions';

export interface IPlayersData {
    roundType: 'buy' | 'regular' | 'free-round' | 'awarded-feature';
    playerId: number;
    externalId: string;
    login: string;
    spins: number;
    bet: number;
    win: number;
    net: number;
    rtp: number;
    link: string;
    testPlayer: boolean;
    currencyId: number;
    fromDate: string;
    toDate: string;
}

export interface IPlayersState {
    isLoading: boolean;
    players?: IPlayersData[];
    sortedPlayersData: IPlayerData[];
    totalItems: number;
    total: any;
    totalLine: any;
}

export const playersInitialState: IPlayersState = {
    isLoading: false,
    sortedPlayersData: [],
    totalItems: 100,
    total: null,
    totalLine: null,
};

const playersReportReducer = (state = playersInitialState, actions: IAction) => {
    switch (actions.type) {
        case PlayersReportTypes.PLAYERS_REPORT_REQUEST: {
            const { fromDate, toDate } = actions.payload;

            localStorageHelper.setChainedValue('user.reports.dates', {
                fromDate,
                toDate,
            });

            return { ...state, isLoading: true };
        }
        //OLD
        case PlayersReportTypes.OLD_PLAYERS_REPORT_REQUEST: {
            const { fromDate, toDate } = actions.payload;

            localStorageHelper.setChainedValue('user.reports.dates', {
                fromDate,
                toDate,
            });

            return { ...state, isLoading: true };
        }

        case PlayersReportTypes.PLAYERS_REPORT_SUCCESS: {
            const { content, total, pagination } = actions.payload.pageableData;
            const dates = localStorageHelper.getChainedValue('user.reports.dates');
            const fromDate = (dates && dates.fromDate) || dateFormatter.getDefaultDate();
            const toDate = (dates && dates.toDate) || dateFormatter.getDefaultDate(false);

            content.forEach((player: IPlayersData) => {
                player.fromDate = dateFormatter.getFormattedForReportDate(fromDate);
                player.toDate = dateFormatter.getFormattedForReportDate(toDate);
                player.link = canAccessPlayerProfile()
                    ? `/casino/players/${player.playerId}/${player.login}`
                    : '';
            });

            return {
                ...state,
                isLoading: false,
                players: content,
                total: total,
                totalItems: pagination.totalRecords,
                sortedPlayersData: [],
            };
        }

        //OLD
        case PlayersReportTypes.OLD_PLAYERS_REPORT_SUCCESS: {
            const { content, total } = actions.payload.pageableData;
            const dates = localStorageHelper.getChainedValue('user.reports.dates');
            const fromDate = (dates && dates.fromDate) || dateFormatter.getDefaultDate();
            const toDate = (dates && dates.toDate) || dateFormatter.getDefaultDate(false);

            content.forEach((player: IPlayersData) => {
                player.fromDate = dateFormatter.getFormattedForReportDate(fromDate);
                player.toDate = dateFormatter.getFormattedForReportDate(toDate);
                player.link = canAccessPlayerProfile()
                    ? `/casino/players/${player.playerId}/${player.login}`
                    : '';
            });

            return {
                ...state,
                isLoading: false,
                players: content,
                totalItems: total.totalRecords,
                sortedPlayersData: [],
            };
        }

        case PlayersReportTypes.PLAYERS_REPORT_TOTAL_SUCCESS: {
            return {
                ...state,
                totalLine: actions.payload.grandTotalData,
            };
        }

        default:
            return state;
    }
};

export default playersReportReducer;
